/**
 * Supported Link types
 * @enum
 */
export enum LinkType  {
  STRING,
  IMAGE,
  OTHER
}
